import React from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'
import { AuthProvider } from './context/AuthContext'
import { SliderProvider } from './context/SliderContext'
import { GalleryProvider } from './contexts/GalleryContext'
import { AlumniProvider } from './contexts/AlumniContext'
import { ManagementProvider } from './contexts/ManagementContext'
import { ImportantDateProvider } from './contexts/ImportantDateContext'

// SEO Components
import SEOHead from './components/SEOHead'
import StructuredData from './components/StructuredData'

// Main Website Components
import Header from './components/Header'
import Hero from './components/Hero'
import About from './components/About'
import Academics from './components/Academics'
import Gallery from './components/Gallery'
import Alumni from './components/Alumni'
import Admissions from './components/Admissions'
import Contact from './components/Contact'
import Footer from './components/Footer'

// Admin Components
import AdminLogin from './components/admin/AdminLogin'
import AdminLayout from './components/admin/AdminLayout'
import Dashboard from './components/admin/Dashboard'
import AdmissionManagement from './components/admin/Admissions'
import GalleryManagement from './components/admin/GalleryManagement'
import AlumniManagement from './components/admin/AlumniManagement'
import ManagementTeam from './components/admin/ManagementTeam'
import SliderManagement from './components/admin/SliderManagement'
import Messages from './components/admin/Messages'
import ImportantDates from './components/admin/ImportantDates'
import ProtectedRoute from './components/admin/ProtectedRoute'

const HOME_CANONICAL = 'https://vdpms.in/'

// Main website component
const MainWebsite = () => {
  return (
    <div className="min-h-screen bg-white">
      <SEOHead canonical={HOME_CANONICAL} />
      <StructuredData />
      <Header />
      <main id="main-content">
        <Hero />
        <About />
        <Academics />
        <Gallery />
        <Alumni />
        <Admissions />
        <Contact />
      </main>
      <Footer />
    </div>
  )
}

function App() {
  return (
    <HelmetProvider>
      <AuthProvider>
        <ImportantDateProvider>
          <AlumniProvider>
            <ManagementProvider>
              <GalleryProvider>
                <SliderProvider>
                  <Router>
                    <a href="#main-content" className="skip-link">
                      Skip to main content
                    </a>
                    <Routes>
                    {/* Main Website Route */}
                    <Route path="/" element={<MainWebsite />} />
                    
                    {/* Admin Routes */}
                    <Route path="/admin/login" element={<AdminLogin />} />
                    
                    {/* Protected Admin Routes */}
                    <Route path="/admin" element={
                      <ProtectedRoute>
                        <AdminLayout />
                      </ProtectedRoute>
                    }>
                      <Route index element={<Dashboard />} />
                      <Route path="dashboard" element={<Dashboard />} />
                      <Route path="slider" element={<SliderManagement />} />
                      <Route path="gallery" element={<GalleryManagement />} />
                      <Route path="management" element={<ManagementTeam />} />
                      <Route path="alumni" element={<AlumniManagement />} />
                      <Route path="admissions" element={<AdmissionManagement />} />
                      <Route path="important-dates" element={<ImportantDates />} />
                      <Route path="messages" element={<Messages />} />
                    </Route>
                    </Routes>
                </Router>
              </SliderProvider>
            </GalleryProvider>
          </ManagementProvider>
        </AlumniProvider>
        </ImportantDateProvider>
      </AuthProvider>
    </HelmetProvider>
  )
}

export default App